import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Typography } from 'antd';
import { ColumnDto, ProjectDto, ColumnTypesEnum } from '@/core';
import { ColumnCard } from './ColumnCard';
import { sort } from '@/utils';
import classes from './ColumnCardsList.module.scss';

type PropsType = {
  projectData: ProjectDto;
  userColumns: ColumnDto[];
};

export const ColumnCardsList = ({ projectData, userColumns }: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [editedCardsIds, setEditedCardsIds] = useState<string[]>([]);
  const sortedColumns = userColumns.sort((a, b) => sort(a.type, b.type));

  const handleClickEdit = (id: string) => setEditedCardsIds((prev) => [...prev, id]);
  const handleStopEditCard = (id: string) =>
    setEditedCardsIds((prev) => prev.filter((editedCardId) => editedCardId !== id));

  return (
    <div className={classes.cardsList}>
      <Row className={classes.cardsListTitle}>
        <Col xs={5} md={4}>
          <Typography.Text>{t('addColumns.type')}</Typography.Text>
        </Col>
        <Col span={10}>
          <Typography.Text>{t('addColumns.sourceName')}</Typography.Text>
        </Col>
        <Col xs={9} md={10}>
          <Typography.Text>{t('addColumns.name')}</Typography.Text>
        </Col>
      </Row>
      {sortedColumns.map((column) => (
        <ColumnCard
          key={column.id}
          onClickMenuEdit={() => handleClickEdit(column.id)}
          isEdit={editedCardsIds.includes(column.id)}
          stopEditCard={() => handleStopEditCard(column.id)}
          projectData={projectData}
          isCardUnremovable={column.type !== ColumnTypesEnum.Other}
          {...column}
        />
      ))}
    </div>
  );
};
